import React from "react";
import { Box, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";

interface DatePickerProps {
  label?: string;
  name: string;
  value: Dayjs | null;
  onChange: (date: Dayjs | null) => void;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  placeholder?: string;
  readOnly?: boolean;
  backgroundColor?: string;
  shouldDisableDate?: (date: Dayjs) => boolean;
}

const CustomDatePicker: React.FC<DatePickerProps> = ({
  label,
  name,
  value,
  onChange,
  required,
  disabled,
  error,
  shouldDisableDate,
  placeholder,
  readOnly,
  backgroundColor,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        marginBottom: error ? "0px" : "8px",
      }}
    >
      {label && (
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "medium",
            fontSize: "12px",
            display: "flex",
            color: "#FFFFFF",
          }}
        >
          {label}{" "}
          {required && (
            <span
              style={{ color: "red", marginLeft: "5px", lineHeight: "1.5" }}
            >
              *
            </span>
          )}
        </Typography>
      )}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={value}
          onChange={onChange}
          disabled={disabled}
          readOnly={readOnly}
          format="DD-MM-YYYY"
          shouldDisableDate={
            shouldDisableDate ||
            ((date) => date && date.isBefore(new Date(), "day"))
          }
          slotProps={{
            textField: {
              name: name,
              fullWidth: true,
              variant: "outlined",
              error: !!error,
              // helperText: error || "",
              placeholder: placeholder,
              sx: {
                color: "#CCCCCC",
                "& .css-1ysp02-MuiButtonBase-root-MuiIconButton-root": {
                  padding: "8px 16px!important",
                },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0px",
                  borderColor: error
                    ? "#d32f2f!important"
                    : "#808080!important",
                  height: "40px",
                  fontSize: "14px",
                  backgroundColor: backgroundColor || "#393939",

                  paddingRight: "7px!important",
                  "& .MuiInputBase-input": {
                    color: "#CCCCCC !important",
                  },
                },
                "&.css-1ysp02-MuiButtonBase-root-MuiIconButton-root:hover": {
                  backgroundColor: "transparent!important",
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "#CCCCCC !important",
                  opacity: 1,
                },

                "& .MuiSvgIcon-root": {
                  color: "#CCCCCC !important",
                },
                "& fieldset": {
                  borderColor: error ? "#d32f2f !important" : "#808080",
                },
                "&:hover fieldset": {
                  borderColor: "#808080 !important",
                },
                "& .MuiIconButton-root": {
                  marginRight: "0px !important",
                  "&:hover": {
                    backgroundColor: "transparent!important",
                  },
                },
              },
            },
          }}
        />
      </LocalizationProvider>
      {error && (
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "medium",
            textAlign: "left",
            color: "#d32f2f",
            fontSize: "12px",
            // paddingTop: "5px",
          }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default CustomDatePicker;
